import React from "react";
import Logo from "shared/Logo/Logo";

const Footer: React.FC = () => {
  return (
    <div className="relative py-10 border-t border-neutral-200 dark:border-neutral-700">
      <div className="container mx-auto">
        <div className="flex justify-between">
          <div className="flex-1">
            <Logo />
          </div>

          <div className="flex-1" />

          <div className="flex-1">
            <h3 className="font-semibold text-neutral-700 dark:text-neutral-200 mb-6">
              Getting Started
            </h3>
            <div className="flex flex-col space-y-4">
              <a
                href="#"
                className="text-neutral-6000 dark:text-neutral-300 hover:text-black dark:hover:text-white"
              >
                What is AgentMatch?
              </a>
              <a
                href="/register"
                className="text-neutral-6000 dark:text-neutral-300 hover:text-black dark:hover:text-white"
              >
                Register your Agency
              </a>
              <a
                href="/register"
                className="text-neutral-6000 dark:text-neutral-300 hover:text-black dark:hover:text-white"
              >
                Register your Brand
              </a>
            </div>
          </div>

          <div className="flex-1">
            <h3 className="font-semibold text-neutral-700 dark:text-neutral-200 mb-6">
              SMARTVIEW360 GmbH
            </h3>
            <div className="text-neutral-6000 dark:text-neutral-300 space-y-2">
              <p>Rathausstr. 26 - 27777</p>
              <p>Ganderkesee - Germany</p>
              <p>Office: +49 40 32 53 74 00</p>
              <p>Fax: +49 40 3 80 17 83 07 55</p>
            </div>
            <div className="flex flex-col space-y-4 mt-6">
              <a
                href="https://www.smartview360.com/datenschutzerklaerung"
                className="text-neutral-6000 dark:text-neutral-300 hover:text-black dark:hover:text-white"
              >
                Datenschutzerklärung
              </a>
              <a
                href="https://www.smartview360.com/impressum"
                className="text-neutral-6000 dark:text-neutral-300 hover:text-black dark:hover:text-white"
              >
                Impressum
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;